module.exports = __webpack_public_path__ + "img/nuxt.129ae7e2.png";